/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Attendees_PlaceholderInputs */

const cs_tasks_protocol_attendees_placeholder = /** @type {(inputs: Tasks_Protocol_Attendees_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jména oddělená čárkou nebo novým řádkem`)
};

const en_tasks_protocol_attendees_placeholder = /** @type {(inputs: Tasks_Protocol_Attendees_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Names separated by comma or new line`)
};

/**
* | output |
* | --- |
* | "Names separated by comma or new line" |
*
* @param {Tasks_Protocol_Attendees_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_attendees_placeholder = /** @type {((inputs?: Tasks_Protocol_Attendees_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Attendees_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_attendees_placeholder(inputs)
	return cs_tasks_protocol_attendees_placeholder(inputs)
});